import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.99975 18.8337C14.6021 18.8337 18.3331 15.1027 18.3331 10.5003C18.3331 5.89795 14.6021 2.16699 9.99975 2.16699C5.39737 2.16699 1.66641 5.89795 1.66641 10.5003C1.66641 15.1027 5.39737 18.8337 9.99975 18.8337Z",
      stroke: "white",
      "stroke-width": "1.66667",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.0036 5.5L10.0031 10.5037L13.5362 14.0367",
      stroke: "white",
      "stroke-width": "1.66667",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }